import { render, staticRenderFns } from "./SchoolListsExportButton.vue?vue&type=template&id=520d666c"
import script from "./SchoolListsExportButton.vue?vue&type=script&lang=js"
export * from "./SchoolListsExportButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports